import * as React from 'react';

import { Skeleton } from '../../ui/skeleton';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface DrawerFormSkeletonProps {
  /** Number of field-row placeholders to render (default: 3). */
  fieldCount?: number;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Generic loading placeholder for a drawer form body.
 * Renders `fieldCount` label + input skeleton rows inside the standard
 * drawer padding, matching the `space-y-4 px-1 py-4` layout used by
 * drawer form content.
 */
export function DrawerFormSkeleton({ fieldCount = 3 }: DrawerFormSkeletonProps): React.JSX.Element {
  return (
    <div aria-label="Loading" className="space-y-4 px-1 py-4" role="status">
      {Array.from({ length: fieldCount }, (_, index) => (
        <div className="space-y-2" key={index}>
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-9 w-full" />
        </div>
      ))}
    </div>
  );
}
